// extracted by mini-css-extract-plugin
export default {"form":"_3QA4h"};